import { ServiceKey } from '@nexla/@types';
import { find } from 'lodash';
import { useSelector } from 'react-redux';
import {
  ACTIVATE_SERVICE_KEY,
  DELETE_SERVICE_KEY,
  PAUSE_SERVICE_KEY,
  ROTATE_SERVICE_KEY,
} from 'js/constants/processTypes';

export function useServiceKeyProcesses(data: ServiceKey) {
  const state = useSelector((s: any) => s);
  const {
    processes: { all: processes },
  } = state;

  const id = data.id;

  return {
    isPausing: !!find(processes, { type: PAUSE_SERVICE_KEY, id }),
    isActivating: !!find(processes, { type: ACTIVATE_SERVICE_KEY, id }),
    isRotating: !!find(processes, { type: ROTATE_SERVICE_KEY, id }),
    isDeleting: !!find(processes, { type: DELETE_SERVICE_KEY, id }),
  };
}
